<template>
    <layout-basic>
       <v-container fluid style="padding-bottom: 0; padding-top: 10px">
      <v-row class="text-start">
        <v-col md="12">
          <v-card flat class="text-right v-card-bg-none">
            <v-card-actions>
              <v-btn color="secondary" outlined class="mr-1 btn btn-primary text-right  " :to="this.$store.getters.admin ? '/admin/courses' : '/course-library'">
                <v-icon class="mr-1" small>fa-chevron-left</v-icon>
                 {{ this.$store.getters.admin ? 'Back to Course Lists' : 'Back to Course Library' }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
      <v-container fluid class="mb-5">
      <div class="btn-info-container">
       
          <v-btn  class="btn btn-primary add-course-button" v-if="loading" color="primary"
          loading></v-btn>
          <v-btn v-else class="btn btn-primary add-course-button" color="primary" 
          @click="handleSaveNotificationSettings" outlined>Save</v-btn>
        
        
          <v-alert color="#FFF6E7" class="custom-border custom-msg-alert"  variant="outlined">
            <template v-slot:prepend> <i class="fas fa-triangle-exclamation" style="color: #f5a623; font-size: 20px; margin-right: 16px;"></i> </template>
            <b>Important:</b> Please save your changes to notification settings before leaving the page, as unsaved changes will be lost.
          </v-alert>
      </div>

      <v-row>
        <v-col md="12" class="Notification-Title">
          User Notifications <small>{{ this.course_name != '' ? '('+ this.course_name  +')' : '' }}</small>
        </v-col>
        <v-alert color="#FFF6E7" class="custom-border custom-msg-alert" variant="outlined">
              <template v-slot:prepend> <i class="fas fa-lightbulb-on" style="color: #f5a623; font-size: 20px; margin-right: 16px;"></i> </template>
              <b>Tips:</b> Use merge fields to automatically insert details such as the learner’s name, course name, or deadline date into your message. For example, Hi <b v-pre>{{FirstName}}</b> will appear as Hi <b>John</b> in the actual notification.
        </v-alert>
      </v-row>
      <v-row>
        <v-col md="12" class="pt-4" cols="12">
          <v-form ref="form">
            
            <v-radio-group
              v-model="shownUp"
              row
              
            >
              <strong class="grey800--text"
                >How would you like to send the notifications?</strong
              >
              <v-radio label="Email" value="1" class="pl-4"></v-radio>
              <v-radio label="Platform" value="2"></v-radio>
              <v-radio label="Both" value="3"></v-radio>
            </v-radio-group>
            <v-row>
              <hr style="width: 100%; height: 2px" />
              <div class="notification-edit-container">
              <v-col sm="12" md="3" class="notification-switch">
                <v-switch
                  v-model="notification.deadline_set"
                  class="input_switch"
                  
                  color="primary"
                  @change="toggleFieldValidation('deadline_set')"
                  hide-details
                >
                  <template v-slot:label>
                    <div>
                      <strong class="grey800--text"
                        >Enable notification on deadline set</strong
                      >
                    </div>
                  </template>
                </v-switch>
              </v-col>
              <v-col sm="12" md="6">
                <div class="tooltip-textarea">
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" class="mr-2">fa fa-question</v-icon>
                        </template>
                        <span>Notify assigned users when a deadline is set on this course. <br/>(Please note: This can be overwritten by global settings).</span
                        >
                      </v-tooltip>
                  <div style="padding:0px !important" class="notification-content">
                    <!-- Merge Fields Dropdown -->
                      <v-select
                        @change="insertMergeField($event,0)" :disabled="!notification.deadline_set"
                        :items="deadlineMergeFields"
                        label="Insert Merge Field"
                        density="comfortable"
                        v-model="selectedMergeField[0]"
                        outlined
                        hide-details="auto"
                      ></v-select>
                    <v-input
                      :rules="[v => customMessageRule(v, notification.deadline_set, ['{{CourseName}}','{{DeadlineDate}}'])]"
                      hide-details="auto"
                      required
                      class="notification-textarea"
                      v-model="notificationContent.deadline_set"
                    >
                    <ckeditor :editor="editor" class="notification-ckeditor" :disabled="!notification.deadline_set" v-model="notificationContent.deadline_set" tag-name="textarea" :config="editorConfig" @ready="onEditorReady($event, 0)"
                     ref="deadline_set"
                    :label="notification.deadline_set ? 'Add a custom notification message' : 'Enable to add a custom message'"
                    ></ckeditor>
                  </v-input>  
                  <span @click.stop="preivewNotification('Course Deadline Set',notificationContent.deadline_set)"  :class="['preview-icon-wrapper', { disabled: !notification.deadline_set }]">
                    <v-icon color="primary" class="preview-icon">mdi-file-search</v-icon>
                  </span>
                </div>
                </div>  
              </v-col>
              </div>
              <hr style="width: 100%; height: 2px" />
              <div class="notification-edit-container">
              <v-col sm="12" md="3" class="notification-switch">
                <v-switch
                  v-model="notification.deadline_changed"
                  class="input_switch"
                  
                  color="primary"
                  @change="toggleFieldValidation('deadline_changed')"
                  hide-details
                >
                  <template v-slot:label>
                    <div>
                      <strong class="grey800--text"
                        >Enable notification on deadline changed</strong
                      >
                    </div>
                  </template>
                </v-switch>
              </v-col>
              <v-col sm="12" md="6">
                <div class="tooltip-textarea">
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" class="mr-2">fa fa-question</v-icon>
                        </template>
                        <span>Notify assigned users when a deadline is changed on this course. <br/>(Please note: This can be overwritten by global settings).</span
                        >
                      </v-tooltip>
                  <div style="padding:0px !important" class="notification-content">
                     <!-- Merge Fields Dropdown -->
                      <v-select
                        @change="insertMergeField($event,1)" :disabled="!notification.deadline_changed"
                        :items="deadlineMergeFields"
                        label="Insert Merge Field"
                        density="comfortable"
                        v-model="selectedMergeField[1]"
                        outlined
                        hide-details="auto"
                      ></v-select>
                    <v-input
                      :rules="[v => customMessageRule(v, notification.deadline_changed, ['{{CourseName}}','{{DeadlineDate}}'])]"
                      hide-details="auto"
                      required
                      class="notification-textarea"
                      v-model="notificationContent.deadline_changed"
                    >
                    <ckeditor :editor="editor" class="notification-ckeditor" :disabled="!notification.deadline_changed" v-model="notificationContent.deadline_changed" tag-name="textarea" :config="editorConfig" @ready="onEditorReady($event, 1)"
                     ref="deadline_changed"
                    :label="notification.deadline_changed ? 'Add a custom notification message' : 'Enable to add a custom message'"
                    ></ckeditor>
                  </v-input>  
                  <span @click.stop="preivewNotification('Course Deadline Changed',notificationContent.deadline_changed)" :class="['preview-icon-wrapper', { disabled: !notification.deadline_changed }]">
                    <v-icon color="primary" class="preview-icon">mdi-file-search</v-icon>
                  </span>
                </div>
                </div>
              </v-col>
              </div>
              <hr style="width: 100%; height: 2px" />
              <div class="notification-edit-container">
              <v-col sm="12" md="3" class="notification-switch">
                <v-switch
                  v-model="notification.missed_deadline"
                  class="input_switch"
                  
                  color="primary"
                  @change="toggleFieldValidation('missed_deadline')"
                  hide-details
                >
                  <template v-slot:label>
                    <div>
                      <strong class="grey800--text"
                        >Enable notification on missed deadline</strong
                      >
                    </div>
                  </template>
                </v-switch>
              </v-col>
              <v-col sm="12" md="6">
                <div class="tooltip-textarea">
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" class="mr-2">fa fa-question</v-icon>
                        </template>
                        <span
                          >Notify assigned users when a deadline is missed on this course. <br/>(Please note: This can be overwritten by global settings).</span
                        >
                      </v-tooltip>
                  <div style="padding:0px !important" class="notification-content">
                     <!-- Merge Fields Dropdown -->
                      <v-select
                        @change="insertMergeField($event,2)" :disabled="!notification.missed_deadline"
                        :items="deadlineMergeFields"
                        label="Insert Merge Field"
                        density="comfortable"
                        v-model="selectedMergeField[2]"
                        outlined
                        hide-details="auto"
                      ></v-select>
                    <v-input
                      :rules="[v => customMessageRule(v, notification.missed_deadline, ['{{CourseName}}','{{DeadlineDate}}'])]"
                      hide-details="auto"
                      required
                      class="notification-textarea"
                      v-model="notificationContent.missed_deadline"
                    >
                    <ckeditor :editor="editor" class="notification-ckeditor" :disabled="!notification.missed_deadline" v-model="notificationContent.missed_deadline" tag-name="textarea" :config="editorConfig" @ready="onEditorReady($event, 2)"
                     ref="missed_deadline"
                    :label="notification.missed_deadline ? 'Add a custom notification message' : 'Enable to add a custom message'"
                    ></ckeditor>
                  </v-input>  
                  <span @click.stop="preivewNotification('Course Deadline Missed', notificationContent.missed_deadline)" :class="['preview-icon-wrapper', { disabled: !notification.missed_deadline }]">
                    <v-icon color="primary" class="preview-icon">mdi-file-search</v-icon>
                  </span>
                </div>
                  </div>
              </v-col>
              </div>
              <hr style="width: 100%; height: 2px" />
              <div class="notification-edit-container">
              <v-col sm="12" md="3" class="notification-switch">
                <v-switch
                  v-model="notification.auto_archived"
                  class="input_switch"
                  
                  color="primary"
                  @change="toggleFieldValidation('auto_archived')"
                  hide-details
                >
                  <template v-slot:label>
                    <div>
                      <strong class="grey800--text">Enable notification on Auto Archive course data</strong>
                    </div>
                  </template>
                </v-switch>
              </v-col>
              <v-col sm="12" md="6">
                <div class="tooltip-textarea">
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" class="mr-2">fa fa-question</v-icon>
                        </template>
                        <span>Notify users when a course assigned to them gets auto archived. <br/>(Please note: This can be overwritten by global settings).</span
                        >
                      </v-tooltip>
                  <div style="padding:0px !important" class="notification-content">
                     <!-- Merge Fields Dropdown -->
                      <v-select
                        @change="insertMergeField($event,3)" :disabled="!notification.auto_archived"
                        :items="courseMergeFields"
                        label="Insert Merge Field"
                        density="comfortable"
                        v-model="selectedMergeField[3]"
                        outlined
                        hide-details="auto"
                      ></v-select>
                    <v-input
                      :rules="[v => customMessageRule(v, notification.auto_archived, ['{{CourseName}}'])]"
                      hide-details="auto"
                      required
                      class="notification-textarea"
                      v-model="notificationContent.auto_archived"
                    >
                    <ckeditor :editor="editor" class="notification-ckeditor" :disabled="!notification.auto_archived" v-model="notificationContent.auto_archived" tag-name="textarea" :config="editorConfig" @ready="onEditorReady($event, 3)"
                     ref="auto_archived"
                    :label="notification.auto_archived ? 'Add a custom notification message' : 'Enable to add a custom message'"
                    ></ckeditor>
                  </v-input>  
                   <span @click.stop="preivewNotification('Course Auto Archived', notificationContent.auto_archived)" :class="['preview-icon-wrapper', { disabled: !notification.auto_archived }]">
                    <v-icon color="primary" class="preview-icon">mdi-file-search</v-icon>
                  </span>
                </div>
                  </div>
              </v-col>
              </div>
              <hr style="width: 100%; height: 2px" />
              <div class="notification-edit-container">
              <v-col sm="12" md="3">
                <div>
                      <strong class="grey800--text">Send a notification [X] days before the deadline:</strong>
                </div>
                </v-col>
                <v-col sm="12" md="2">
                  <div class="tooltip-textarea">
                    <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" class="mr-2">fa fa-question</v-icon>
                        </template>
                        <span>How many days in advance should assigned users be notified before the course deadline? <br/>(Please note: This can be overwritten by global settings).</span>
                      </v-tooltip>
                <v-text-field
                  :error-messages="messages.deadline_before"
                  v-model="notification.deadline_before"
                  
                  type="number"
                  :min="0"
                  :max="30"
                  outlined
                  @keypress="NumbersOnly"
                  @blur="handleBlur('deadline_before')" 
                  hide-details="auto"
                >
                </v-text-field>
                </div>
                </v-col>
              
              <v-col sm="12" md="6">
                  <div style="padding:0px !important" class="notification-content">
                     <!-- Merge Fields Dropdown -->
                      <v-select
                        @change="insertMergeField($event,4)" 
                        :items="deadlineMergeFields"
                        label="Insert Merge Field"
                        density="comfortable"
                        v-model="selectedMergeField[4]"
                        outlined
                        hide-details="auto"
                      ></v-select>
                    <v-input
                      :rules="[v => customMessageRule(v, notification.deadline_before, ['{{CourseName}}','{{DeadlineDate}}'])]"
                      hide-details="auto"
                      required
                      class="notification-textarea"
                      v-model="notificationContent.deadline_before"
                    >
                    <ckeditor :editor="editor" class="notification-ckeditor"  v-model="notificationContent.deadline_before" tag-name="textarea" :config="editorConfig" @ready="onEditorReady($event, 4)"
                     ref="deadline_before"
                    label="Add a custom notification message"
                    ></ckeditor>
                  </v-input>
                  <span @click.stop="preivewNotification('Before Course Deadline', notificationContent.deadline_before)" :class="['preview-icon-wrapper', { disabled: !notification.deadline_before }]">
                    <v-icon color="primary" class="preview-icon">mdi-file-search</v-icon>
                  </span>
                </div>
              </v-col>
              </div>
              <hr style="width: 100%; height: 2px" />
              <div class="notification-edit-container">
              <v-col sm="12" md="3">
                <div>
                      <strong class="grey800--text">Send a notification to idle user after [X] days:</strong>
                </div>
                </v-col>
                <v-col sm="12" md="2">
                  <div class="tooltip-textarea">
                    <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" class="mr-2">fa fa-question</v-icon>
                        </template>
                        <span>After how many days of inactivity should assigned users be notified if they haven’t started this course? <br/>(Please note: This can be overwritten by global settings).</span>
                      </v-tooltip>
                <v-text-field
                  v-model="notification.idle_after"
                  :error-messages="messages.idle_after"
                  
                  type="number"
                  :min="0"
                  :max="30"
                  outlined
                  @keypress="NumbersOnly"
                  @blur="handleBlur('idle_after')" 
                  hide-details="auto"
                >
                </v-text-field>
              </div>
              </v-col>
              <v-col sm="12" md="6">
                  <div style="padding:0px !important" class="notification-content">
                    <!-- Merge Fields Dropdown -->
                      <v-select
                        @change="insertMergeField($event,5)" 
                        :items="courseMergeFields"
                        label="Insert Merge Field"
                        density="comfortable"
                        v-model="selectedMergeField[5]"
                        outlined
                        hide-details="auto"
                      ></v-select>
                    <v-input
                      :rules="[v => customMessageRule(v, notification.idle_after, ['{{CourseName}}'])]"
                      hide-details="auto"
                      required
                      class="notification-textarea"
                      v-model="notificationContent.idle_after"
                    >
                    <ckeditor :editor="editor" class="notification-ckeditor"  v-model="notificationContent.idle_after" tag-name="textarea" :config="editorConfig" @ready="onEditorReady($event, 5)"
                     ref="idle_after"
                    label="Add a custom notification message"
                    ></ckeditor>
                  </v-input>  
                  <span @click.stop="preivewNotification('Course Idle', notificationContent.idle_after)" :class="['preview-icon-wrapper', { disabled: !notification.idle_after }]">
                    <v-icon color="primary" class="preview-icon">mdi-file-search</v-icon>
                  </span> 
                </div>
              </v-col>
              </div>
              <hr style="width: 100%; height: 2px" />
              <v-col cols="12" class="Full-Course-Library-Title">
                Company Admin Notifications
              </v-col>
              <div class="notification-edit-container">
              <v-col sm="12" md="3" class="notification-switch">
                <v-switch
                  v-model="notification.course_status_changed"
                  class="input_switch"
                  
                  color="primary"
                  @change="toggleFieldValidation('course_status_changed')"
                  hide-details
                >
                  <template v-slot:label>
                    <div>
                      <strong class="grey800--text"
                        >Notify admin when a user starts a course</strong
                      >
                    </div>
                  </template>
                </v-switch>
              </v-col>
              <v-col sm="12" md="6">
                <div class="tooltip-textarea">
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" class="mr-2">fa fa-question</v-icon>
                        </template>
                        <span
                          >When a user starts this course assigned by a company admin, the admin will receive a notification.<br/> (Please note: This can be overwritten by global settings).</span
                        >
                      </v-tooltip>
                  <div style="padding:0px !important" class="notification-content">
                    <!-- Merge Fields Dropdown -->
                      <v-select
                        @change="insertMergeField($event,6)" :disabled="!notification.course_status_changed"
                        :items="adminMergeFields"
                        label="Insert Merge Field"
                        density="comfortable"
                        v-model="selectedMergeField[6]"
                        outlined
                        hide-details="auto"
                      ></v-select>
                     <v-input
                      :rules="[v => customMessageRule(v, notification.course_status_changed, ['{{CourseName}}','{{Email}}'])]"
                      hide-details="auto"
                      required
                      class="notification-textarea"
                      v-model="notificationContent.course_status_changed"
                    >
                    <ckeditor :editor="editor" class="notification-ckeditor" ref="course_status_changed"  v-model="notificationContent.course_status_changed"  tag-name="textarea" :config="editorConfig" @ready="onEditorReady($event, 6)"
                    :label="notification.course_status_changed ? 'Add a custom notification message' : 'Enable to add a custom message'"
                    :disabled="!notification.course_status_changed"
                    ></ckeditor>
                    </v-input> 
                    <span @click.stop="preivewNotification('Course Start', notificationContent.course_status_changed)" :class="['preview-icon-wrapper', { disabled: !notification.course_status_changed }]">
                    <v-icon color="primary" class="preview-icon">mdi-file-search</v-icon>
                  </span>
                </div>
                  </div>
              </v-col>
              </div>
              <hr style="width: 100%; height: 2px" />
              <div class="notification-edit-container">
              <v-col sm="12" md="3" class="notification-switch">
                <v-switch
                  v-model="notification.course_completion"
                  class="input_switch"
                  
                  color="primary"
                  @change="toggleFieldValidation('course_completion')"
                  hide-details
                >
                  <template v-slot:label>
                    <div>
                      <strong class="grey800--text"
                        >Notify admin when a user completes a
                        course</strong
                      >
                    </div>
                  </template>
                </v-switch>
              </v-col>
              <v-col sm="12" md="6">
                <div class="tooltip-textarea">
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" class="mr-2">fa fa-question</v-icon>
                        </template>
                        <span
                          >When a user completes this course assigned by a company admin, the admin will receive a notification. <br/>(Please note: This can be overwritten by global settings).</span
                        >
                      </v-tooltip>
                  <div style="padding:0px !important" class="notification-content">
                    <!-- Merge Fields Dropdown -->
                      <v-select
                        @change="insertMergeField($event,7)" :disabled="!notification.course_completion"
                        :items="adminMergeFields"
                        label="Insert Merge Field"
                        density="comfortable"
                        v-model="selectedMergeField[7]"
                        outlined
                        hide-details="auto"
                      ></v-select>
                     <v-input
                      :rules="[v => customMessageRule(v, notification.course_completion, ['{{CourseName}}','{{Email}}'])]"
                      hide-details="auto"
                      required
                      class="notification-textarea"
                      v-model="notificationContent.course_completion"
                    >
                    <ckeditor :editor="editor" class="notification-ckeditor" ref="course_completion"  v-model="notificationContent.course_completion"  tag-name="textarea" :config="editorConfig" @ready="onEditorReady($event, 7)"
                    :label="notification.course_completion ? 'Add a custom notification message' : 'Enable to add a custom message'"
                    :disabled="!notification.course_completion"
                    ></ckeditor>
                    </v-input>
                    <span @click.stop="preivewNotification('Course Complete', notificationContent.course_completion)" :class="['preview-icon-wrapper', { disabled: !notification.course_completion }]">
                    <v-icon color="primary" class="preview-icon">mdi-file-search</v-icon>
                  </span>
                </div>
                  </div>
              </v-col>
              </div>
              <hr style="width: 100%; height: 2px" />
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
    <!-- Dialog -->
        <PreivewDialog
        :isOpen="dialog"
        :dialogTitle="dialogTitle"
        :dialogData="dialogData"
        :headerImgSrc="headerImgSrc"
        :footerImgSrc="footerImgSrc"
        @close="closeDialog"
        />
    </layout-basic>
</template>
<script>
import LayoutBasic from '@/layouts/Dashboard';
import notificationAPI from '@/api/notification.js';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import PreivewDialog from '@/components/PreviewDialog';
export default {
  name: 'CourseNotifications',
  components: {
        LayoutBasic,
        PreivewDialog
  },
  data() {
    return {
      id: this.$route.params.id,
      course_name: '',
      notification: {},
      messages: {},
      getBy: '',
      shownUp: '',
      successMessage: 'Notification Settings Successfully Updated.',
      errorMessage:
        'Oops, something went wrong! Please check information is correct.',
      loading: false,
      notificationContent : {},
      editorConfig: {
        placeholder: 'Type your custom notification message here...', // <-- placeholder here
        toolbar: {
          items: [
            'undo', 'redo',
            '|', 'heading',
            '|', 'bold', 'italic',
            '|', 'bulletedList', 'numberedList',
            '|', 'link'
          ]
        },
      },
      editor: ClassicEditor,
      editors: [
        { content: "", instance: null },
        { content: "", instance: null },
        { content: "", instance: null },
        { content: "", instance: null },
        { content: "", instance: null },
        { content: "", instance: null },
        { content: "", instance: null },
        { content: "", instance: null },
      ],
       courseMergeFields: [
        { text: "Select a merge field...", value: null },
        { text: "{{FirstName}}", value: "{{FirstName}}" },
        { text: "{{LastName}}", value: "{{LastName}}" },
        { text: "{{CourseName}}", value: "{{CourseName}}" },
        { text: "{{CourseLink}}", value: "{{CourseLink}}" },
      ],
      deadlineMergeFields: [
        { text: "Select a merge field...", value: null },
        { text: "{{FirstName}}", value: "{{FirstName}}" },
        { text: "{{LastName}}", value: "{{LastName}}" },
        { text: "{{CourseName}}", value: "{{CourseName}}" },
        { text: "{{DeadlineDate}}", value: "{{DeadlineDate}}" },
        { text: "{{CourseLink}}", value: "{{CourseLink}}" },
      ],
      adminMergeFields: [
        { text: "Select a merge field...", value: null },
        { text: "{{FirstName}}", value: "{{FirstName}}" },
        { text: "{{LastName}}", value: "{{LastName}}" },
        { text: "{{Email}}", value: "{{Email}}" },
        { text: "{{CourseName}}", value: "{{CourseName}}" },
      ],
      selectedMergeField: [], // keep array if you have multiple editors
      dialog: false,
      dialogTitle : '',
      dialogData: '',
      headerImgSrc: '',
      footerImgSrc: '',
      allowCustomization: 0,
      customized_notification: 0,
      headerS3Url: '',
      footerS3Url: ''
    };
  },
  mounted() {
    this.getNotificationSettings();
  },
  methods: {
    getNotificationSettings() {
      notificationAPI.getCourseNotificationSetting(this.id).then((resp) => {
        if (resp.data.data.settings) {
          this.notification = resp.data.data.settings;
          if (this.notification.notification_get_by == 1) this.getBy = '1';
          else if (this.notification.notification_get_by == 2) this.getBy = '2';
          else this.getBy = '3';

          if (this.notification.notification_shown_up == 1) this.shownUp = '1';
          else if (this.notification.notification_shown_up == 2)
            this.shownUp = '2';
          else this.shownUp = '3';
        } else {
          this.getBy = '2';
          this.shownUp = '3';
        }
        this.notificationContent = resp.data.data.content;
        this.course_name = resp.data.data.course_name;
        this.allowCustomization = resp.data.data.allow_customiztion;
        this.customized_notification = resp.data.data.customized_notification;
        this.headerS3Url = resp.data.data.header_logo.url;
        this.footerS3Url = resp.data.data.footer_logo.url;
      }) .catch(() => {
          this.$snotify.error('No course found. Please choose a correct course to proceed.');
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
                this.$router.push({ path: '/admin/courses' });
            },300);
        });
    },
    handleSaveNotificationSettings() {
      this.$snotify.confirm('Are you sure you want to save the changes?', {
        backdrop: 0.3,
        buttons: [
          { text: "No", className: 'toast-cancel-button' },
          {
            text: "Yes", className: 'toast-continue-button',
            action: toast => this.AddUpdateNotificationSetting()
          }          
        ]
      });
    },
    AddUpdateNotificationSetting() {
      this.$snotify.remove(); // Remove the confirmation toast
      const backdrop = document.querySelector('.snotify-backdrop');
      if (backdrop) {
          backdrop.parentNode.removeChild(backdrop);
      }
      this.loading = true;
      if(this.$refs.form.validate()){
      notificationAPI
        .updateCourseNotification(
          this.notification,
          this.notificationContent,
          this.getBy,
          this.shownUp,
          this.id
        )
        .then(() => {
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch((err) => {
          this.valid = false;
          this.messages = this.$gf.errorResponse(err);
          this.$snotify.error(this.errorMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
      }else{
        this.loading = false;
      }
    },
    NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) || charCode == 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    handleBlur(fieldName){
      const value = parseInt(this.notification[fieldName], 10);
      if (value > 30) {
        this.notification[fieldName] = 30;
      }
    },
    customMessageRule(value, enabled, requiredFields = []) {
      if ( enabled && (this.shownUp == 1 || this.shownUp == 3)) {
          //Check empty value
          if (!value || !value.trim()) {
            return "Notification content is required.";
          }
         
           //Normalize case
          const content = value.toLowerCase();

          //Handle multiple required merge fields
          const missing = requiredFields.filter(
            (field) => !content.includes(field.toLowerCase())
          );

          //If missing any fields, return error
          if (missing.length > 0) {
            const formatted = missing.join(", ");
            return `Missing required merge field${missing.length > 1 ? "s" : ""}: ${formatted}`;
          }
      }
      return true
    },
    toggleFieldValidation(field) {
    const switchItem = this.notification[field];
    if (!switchItem) {
      this.$nextTick(() => {
        this.$refs[field].resetValidation();
      });
    }
  },
  onEditorReady(editor, index) {
      this.editors[index].instance = editor;
    },
    insertMergeField(field, index) {
      if (!field) return

      const editor = this.editors[index].instance;
      if (editor) {
        editor.model.change(writer => {
          let insertPosition = editor.model.document.selection.getLastPosition();
          // If no selection, insert at the end of document
          if (!insertPosition) {
            insertPosition = editor.model.createPositionAt(editor.model.document.getRoot(), 'end');
          }
          writer.insertText(field, insertPosition);
          // ✅ Move cursor after inserted text
          const newPosition = insertPosition.getShiftedBy(field.length);
          writer.setSelection(newPosition);
        });
         // ✅ Focus editor so user can continue typing
        editor.editing.view.focus();
      }

          // Reset ONLY this select
    this.$nextTick(() => {
      // 1) reset the v-model
      this.selectedMergeField.splice(index, 1, null);
    });

    },
    preivewNotification(title,content) {
      this.dialogTitle = title;
      this.dialogData = content;
      
      this.dialog = true;
      if(this.allowCustomization && this.customized_notification){
        this.headerImgSrc = this.headerS3Url;
        this.footerImgSrc = this.footerS3Url;
      }else{
        this.headerImgSrc = this.footerImgSrc = '';
      }
      document.getElementById('improve').style.pointerEvents = 'none';
      document.getElementById('navbar-collapse').style.pointerEvents = 'none';
    },
    closeDialog() {
      document.getElementById('improve').style.pointerEvents = 'unset';
      document.getElementById('navbar-collapse').style.pointerEvents = 'unset';
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.flex-end-notification {
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (min-width: 768px) {
  .flex-end-notification {
    justify-content: end !important;
  }
}
@media (max-width: 767px) {
  .Notification-Title{
    font-size: 18px !important;
  }
  .btn-info-container, .notification-edit-container {
    display: block !important;
  }
  .custom-msg-alert{
    margin-top: 10px;
  }
  .tooltip-textarea {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
    
  .tooltip-textarea .v-icon {
    margin-bottom: 10px;
  }
    
  .tooltip-textarea .v-input {
    width: 100%;
  }

 .tooltip-textarea .color-input {
    margin-top: 15px;
  }


  .notification-content{
    position: relative;
    width: 100% !important;
  }

  .preview-icon{
    position: unset !important;
    margin-top: 5px;
  }
  .notification-edit-container{
    width: 100% !important;
  }
  .header-logo, .footer-image{
    width: 100% !important;
  }
}
.sticky{
  position: fixed;
  top: 74px;
  right: 22px;
  z-index: 10;
  background-color: white;
  padding: 0 10px;
}

@media screen and (max-width: 960px) {
  .sticky{
    top: 64px;
  }
}

@media screen and (max-width: 460px) {
  .sticky{
    top: 115px;
    border: 1px solid #fff;
  }
}

.Notification-Title{
  width: 166px;
    font-family: Source Sans Pro;
    font-size: 20px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: normal;
    color: #162b44;
    padding-left: 12px;
    margin: 0;
    display: block;
}
.btn-info-container{
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 20px;
}
.custom-msg-alert{
  padding: 10px;
  margin-bottom: 5px;
}
.notification-edit-container{
  display: flex;
  align-items: center;
  width: 90%;
}
.notification-textarea {
  width: 100%;
  max-width: 600px; /* Optional: control size */
}
.notification-switch{
  display: inline-flex;
}
@media (min-width: 768px) and (max-width: 1024px) {
  .notification-edit-container{
    display: block;
  }
  .tooltip-textarea {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
    
  .tooltip-textarea .v-icon {
    margin-bottom: 10px;
  }
    
  .tooltip-textarea .v-input {
    width: 100%;
  }
   .notification-content .v-select{
    width: 215px;
  }
}

@media (min-width: 820px) and (max-width: 1180px) {
  .notification-edit-container{
    display: block;
  }
 .tooltip-textarea {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
    
  .tooltip-textarea .v-icon {
    margin-bottom: 10px;
  }
    
  .tooltip-textarea .v-input {
    width: 100%;
  }
  .notification-content .v-select{
    width: 215px;
  }
}
.notification-content{
  position: relative;
  width: 600px;
}

.preview-icon{
  width: 25px;
  position: absolute;
  right: -40px;
  top: 35px;
  cursor: pointer;
  font-size:25px !important
}

.preview-icon-wrapper {
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.preview-icon-wrapper.disabled {
  opacity: 0.4;
  pointer-events: none;
  cursor: not-allowed;
}
</style>

